import React from 'react'
import { 
	connect as formikConnect, 
	FieldArray 
} from 'formik'

import FormField from '@modules/form/components/FormField'

import NoValue from '../NoValue'

const isTrue = v => v === 'true' || v === true;

@formikConnect
class JobTypeRates extends React.Component {

	constructor(props) {
		super(props);
		this.state = { 
			jobTypes: [],
			fetched: false,
		}
	}

	get isAWRApplicable() {
		const { form } = this.props;
		return isTrue(form.values.AWRApplicable);
	}

	get newJobTypeRow() {
		return {
			jobType: '',
			standard: {
				payRate: '',
				chargeRate: '',
			},
			AWR: {
				payRate: '',
				chargeRate: '',
			}
		}
	}

  get availableJobTypes() {
  	const { field } = this.props;

  	var selectedJobTypeIDs = field.value ? field.value.map(v => v.jobType._id) : [];

  	return this.state.jobTypes.filter((jobType) => {
  		const alreadySelected = selectedJobTypeIDs.includes(jobType.value._id);
  		return !alreadySelected;
  	})
  }

	docToOption(doc) {
    return {
      label: doc.label,
      value: doc,
      doc: doc,
    }
  }

	getSubFields(fieldIndex, selectOptions) {
		const { field } = this.props;
		const fieldPrefix = `${field.name}.${fieldIndex}`;
		var subFields = [
			{
				name: `${fieldPrefix}.jobType`,
				component: 'Select',
				options: selectOptions,
			},
			{
				name: `${fieldPrefix}.standard.payRate`,
				type: 'number',
			},
			{
				name: `${fieldPrefix}.standard.chargeRate`,
				type: 'number',
			},
		];

		if(this.isAWRApplicable) {
			subFields = subFields.concat([
				{
					name: `${fieldPrefix}.AWR.payRate`,
					type: 'number',
				},
				{
					name: `${fieldPrefix}.AWR.chargeRate`,
					type: 'number',
				},
			])
		}

		return subFields;
	}

	async fetchOptions() {
		// TODO: figure out a way to set unlimited
		var data = await fetch(`/api/jobtype?limit=9999`).then(res => res.json())
    this.setState({ 
    	jobTypes: data.docs.map(this.docToOption),
    	fetched: true,
    })
	}

	get shouldFetch() {
		return !this.state.fetched && this.props.isEditing;
	}

	componentDidMount() {
		if(this.shouldFetch) this.fetchOptions();
	}

	componentDidUpdate() {
		if(this.shouldFetch) this.fetchOptions();
	}

	render() {
		const { field, isEditing } = this.props;
	  return (
	  	<FieldArray name={field.name} render={arrayHelpers => {

	  		if(!isEditing && !(field.value && field.value.length)) 
	  			return <NoValue />
				
				return (
					<div>
	  				{this.renderTable(arrayHelpers)}
						{
							isEditing
							&& <button type="button" className="btn btn-primary" onClick={() => arrayHelpers.push(this.newJobTypeRow)}>+ add new</button>
						}
					</div>	
				)

	  	}} />
	  )
	}

	renderTable(arrayHelpers) {
		return (
  		<table className="JobTypeRates">	
  			<thead>
  				{this.renderTableHeaders()}
  			</thead>
  			<tbody>
  				{this.renderTableBody(arrayHelpers)}
  			</tbody>
			</table>
		)
	}

	renderTableHeaders() {
		var headers = ['Job Type', 'Pay Rate', 'Charge Rate'];

		if(this.isAWRApplicable)
			headers = headers.concat(['AWR Pay Rate', 'AWR Charge Rate']);

		// Append empty header for buttons column
		headers.push('');

		return <tr>{headers.map((label, i) => <th key={i}>{label}</th>)}</tr>;
	}

	renderTableBody(arrayHelpers) {
		const { field, isEditing} = this.props;
		const availableJobTypes = this.availableJobTypes;

		// TODO: work out why this ternary is needed on the staging server and not locally (run staging build locally?)
		return field.value 
			? field.value.map((v, i) => {
				const subFields = this.getSubFields(i, availableJobTypes);
				const key = v && v._id ? v._id : i;
				return (
					<tr key={key}>
						{ subFields.map((subField, j) => ( 
							<td key={j}>
								<FormField {...subField} isEditing={isEditing} />
							</td>
						))}
						<td>
							{
								isEditing &&
								<button type="button" className="btn btn-primary" onClick={() => arrayHelpers.remove(i)}>delete</button>
							}
						</td>
					</tr>
				);	
			})
			: '';
	}

}

export default JobTypeRates;


// WEBPACK FOOTER //
// ./src/modules/form/components/input/JobTypeRates.jsx